import { Variants } from 'motion/react'
import { filterTiming } from '../TagFilter/filterAnimation'

// Every timing of the keyword filter's animation in seconds, it follows the theme filter's.
// The overlay fades in, then the letter columns rise in one after the other from the left, the footer
// slides up and the close button spins in, on close the columns and the footer fade out at once while
// the overlay fades away.
// Inside a column every tag fades in after a random delay, so the cloud builds up tag by tag.
// They are a css animation: there can be hundreds of them, and their hover is a css transform.
// The columns and the tags only move, never scale: the tag clouds are fitted from their measured sizes
export const keywordsFilterTiming = {
  overlay: filterTiming.overlay,
  open: {
    // the theme buttons' overshoot, so the columns pop into place
    column: { duration: 0.5, ease: [0.34, 1.56, 0.64, 1] },
    footer: { delay: 0.3, duration: 0.5, ease: [0.2, 0, 0, 1] },
    // the columns start once the overlay has mostly faded in
    columnDelay: 0.15,
    columnStagger: 0.06,
    // about as many columns as fit on a wide screen, the ones after them rise in with the last of them
    staggeredColumns: 8,
    // after their column has started to rise
    tag: { delay: 0.1, duration: 0.6, ease: [0.2, 0, 0, 1] },
    // on top of the tag's delay
    tagMaxRandomDelay: 1,
  },
  close: {
    column: filterTiming.close.button,
    footer: filterTiming.close.button,
  },
} as const

export const overlayVariants: Variants = {
  hidden: { opacity: 0, transition: keywordsFilterTiming.overlay },
  visible: { opacity: 1, transition: keywordsFilterTiming.overlay },
}

export const getColumnDelay = (index: number) => {
  const { columnDelay, columnStagger, staggeredColumns } = keywordsFilterTiming.open
  return columnDelay + Math.min(index, staggeredColumns) * columnStagger
}

// the letter columns, they follow the overlay's variant, the custom value is the column's index
export const columnVariants: Variants = {
  hidden: { opacity: 0, y: 24, transition: keywordsFilterTiming.close.column },
  visible: (index: number) => ({
    opacity: 1,
    y: 0,
    transition: { ...keywordsFilterTiming.open.column, delay: getColumnDelay(index) },
  }),
}

export const getRandomTagDelay = () => Math.random() * keywordsFilterTiming.open.tagMaxRandomDelay

// The css animation of a tag, its column's delay comes from the column's --column-delay
export const getTagAnimation = (randomDelay: number) => {
  const { tag } = keywordsFilterTiming.open
  const delay = tag.delay + randomDelay
  const ease = `cubic-bezier(${tag.ease.join(',')})`

  return `keyword-tag-in ${tag.duration}s ${ease} calc(var(--column-delay) + ${delay}s) both`
}

// the footer, it follows the overlay's variant
export const footerVariants: Variants = {
  hidden: { opacity: 0, y: 16, transition: keywordsFilterTiming.close.footer },
  visible: { opacity: 1, y: 0, transition: keywordsFilterTiming.open.footer },
}
